import nearestPoint from '@turf/nearest-point';
import _ from 'lodash';
import * as ActionTypes from '../actions/actionTypes';

const initialState = { features: {}, active: null };

function _toGeoJson(features) {
  return { type: 'FeatureCollection', features: _.values(features) };
}

function _cloneActive(active) {
  const new_active = { ...active };
  new_active.properties.data = { ...active.properties.data };
  return new_active;
}

// Remove days with no changes. Returns true if no days are left.
function _cleanAndReturnIsEmpty(active) {
  const data = active.properties.data;
  const keys = _.keys(data);

  keys.forEach(k => {
    if (0 === _.keys(data[k]).length) {
      delete data[k];
    }
  });

  return 0 === _.keys(data).length;
}

function _createActive(action) {
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [action.lng, action.lat]
    },
    properties: {
      key: action.mgrs,
      data: {},
      burn: action.burn
    }
  };
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.POPULATE_MANUAL_WEATHER_DATA:
      return {
        ...state,
        features: action.features
      };

    case ActionTypes.SET_MANUAL_WEATHER_DATA:
      let new_active = state.active ? _cloneActive(state.active) : _createActive(action);
      if (Object.keys(action.data).length > 0) {
        new_active.properties.data[action.time] = {
          ...(new_active.properties.data[action.time] || {}),
          ...action.data
        };
      }
      const new_features = { ...state.features };
      if (_cleanAndReturnIsEmpty(new_active)) {
        delete new_features[new_active.properties.key];
        new_active = null;
      } else {
        new_features[new_active.properties.key] = new_active;
      }

      return {
        ...state,
        features: new_features,
        active: new_active
      };

    case ActionTypes.SET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
      let new_sv_active = state.active ? _cloneActive(state.active) : _createActive(action);
      const new_sv_data = new_sv_active.properties.data;
      action.weather_row_keys.forEach((row_key) => {
        if (!new_sv_data[row_key]) {
          new_sv_data[row_key] = {};
        }
        new_sv_data[row_key][action.indicator_key] = action.value;
      });

      const new_sv_features = { ...state.features };
      if (_cleanAndReturnIsEmpty(new_sv_active)) {
        delete new_sv_features[new_sv_active.properties.key];
        new_sv_active = null;
      } else {
        new_sv_features[new_sv_active.properties.key] = new_sv_active;
      }

      return {
        ...state,
        features: new_sv_features,
        active: new_sv_active
      };

    case ActionTypes.RESET_MANUAL_WEATHER_DATA:
      if (state.active) {
        let new_active = _cloneActive(state.active);
        delete new_active.properties.data[action.time];

        const new_features = { ...state.features };
        if (_cleanAndReturnIsEmpty(new_active)) {
          delete new_features[new_active.properties.key];
          new_active = null;
        } else {
          new_features[new_active.properties.key] = new_active;
        }

        return {
          ...state,
          features: new_features,
          active: new_active
        };
      } else {
        return state;
      }

    case ActionTypes.RESET_MANUAL_WEATHER_DATA_SINGLE_VARIABLE:
      if (state.active) {
        let new_rsv_active = _cloneActive(state.active);
        _.forOwn(new_rsv_active.properties.data, (row) => {
          delete row[action.indicator_key];
        });

        const new_rsv_features = { ...state.features };
        if (_cleanAndReturnIsEmpty(new_rsv_active)) {
          delete new_rsv_features[new_rsv_active.properties.key];
          new_rsv_active = null;
        } else {
          new_rsv_features[new_rsv_active.properties.key] = new_rsv_active;
        }

        return {
          ...state,
          features: new_rsv_features,
          active: new_rsv_active
        };
      } else {
        return state;
      }

    case ActionTypes.RESET_ALL_MANUAL_WEATHER_DATA:
      if (state.active) {
        const new_features = { ...state.features };
        delete new_features[state.active.properties.key];
        return {
          ...state,
          features: new_features,
          active: null
        };
      } else {
        return state;
      }

    case ActionTypes.SET_ACTIVE_POINT:
    case ActionTypes.FIND_NEAREST_MANUAL_WEATHER:
      let active;
      if (_.values(state.features).length && action.latlng) {
        const geo_json = _toGeoJson(state.features);
        const nearest = nearestPoint([action.latlng.lng, action.latlng.lat], geo_json);
        // Ignore if outside 1km
        if (nearest && nearest.properties.distanceToPoint < 1) {
          active = nearest;
        }
      }
      return {
        ...state,
        active
      };

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/manual_weather.js